import React, { useState, useEffect } from 'react';
import '../styles/components/VariationSelector.scss';

const VariationSelector = React.memo(
  ({ variations, selectedVariation, onSelectVariation }) => {
    const [currentVariation, setCurrentVariation] = useState(selectedVariation);

    const variationList = Array.isArray(variations)
      ? variations.map((item) =>
          typeof item === 'object'
            ? item.Variedad?.trim() ||
              item['Variedad']?.trim() ||
              item.Codigo ||
              ''
            : String(item)
        )
      : Object.keys(variations);

    useEffect(() => {
      setCurrentVariation(selectedVariation);
    }, [selectedVariation]);

    const handleSelect = (variation) => {
      setCurrentVariation(variation);
      onSelectVariation(variation);
    };

    return (
      <div className="VariationSelector">
        {variationList.map((variation) => (
          <label key={variation} className="VariationSelector__label">
            <input
              type="radio"
              name="variation"
              value={variation}
              checked={currentVariation === variation}
              onChange={() => handleSelect(variation)}
            />
            <span className="VariationSelector__option">
              {variation}
            </span>
          </label>
        ))}
      </div>
    );
  }
);

export default VariationSelector;
